import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a73200f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "update-transcript" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "bg-white border px-6 py-4 mt-6"
}
const _hoisted_5 = { class: "flex flex-col items-center justify-center select-none" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Загрузка транскрипта...", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-400" }, "При получении транскрипта произошла ошибка", -1))
const _hoisted_8 = { class: "bg-white border px-6 py-4 mt-3 grid grid-cols-2 items-start" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Не указан", -1))
const _hoisted_10 = {
  key: 0,
  class: "bg-white border px-6 py-4 mt-3"
}
const _hoisted_11 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "bg-white border px-6 py-4 mt-3 text-center select-none"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm" }, "Нет накладных", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "bg-white border px-6 py-4 mt-3" }
const _hoisted_17 = { class: "grid grid-cols-4 gap-3" }
const _hoisted_18 = {
  key: 0,
  class: "select-none flex items-center justify-center flex-col"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Список пуст", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "grid grid-cols-4 gap-3 mt-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_25 = { class: "flex items-center justify-end mt-2" }
const _hoisted_26 = { class: "mt-6 flex items-center justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Транскрипт" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _ctx.onRouteBack
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_6
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_7,
                    _createVNode(_component_the_button, {
                      class: "primary small mt-2",
                      onClick: _ctx.loadTranscript
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Обновить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", null, [
              _createElementVNode("p", {
                class: _normalizeClass({
                            'text-red-400': _ctx.isNotHaveActNumber,
                        })
              }, [
                (_ctx.isNotHaveActNumber)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Отсутствует номер акта, редактирование невозможно ")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Номер акта: " + _toDisplayString(_ctx.state.transcript.actNumber), 1)
                    ], 64))
              ], 2),
              _createElementVNode("p", null, "Дата создания: " + _toDisplayString(_ctx.state.transcript.actFrom1CCreatedAt), 1),
              _createElementVNode("p", null, [
                (Boolean(_ctx.state.transcript.company))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Контрагент: " + _toDisplayString(_ctx.state.transcript.company.name), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Контрагент: "),
                      _hoisted_9
                    ], 64))
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_the_input, {
                value: _ctx.state.turnoverDate,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.turnoverDate) = $event)),
                disabled: _ctx.isNotHaveActNumber || _ctx.state.is_submit_loading,
                "is-invalid": _ctx.state_form$.turnoverDate.$error,
                "validation-errors": _ctx.state_form$.turnoverDate.$errors,
                type: "date",
                placeholder: "Дата АВР"
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
            ])
          ]),
          _createVNode(_component_page_title, {
            title: `Накладные (${_ctx.state.calculations.length})`,
            class: "mt-6"
          }, null, 8, ["title"]),
          (_ctx.state.calculations.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.calculations, (calculation) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: calculation.id,
                      class: "border border-gray-300 rounded px-3 py-1 flex items-center justify-between"
                    }, [
                      _createElementVNode("div", null, _toDisplayString(calculation.invoiceNumber), 1),
                      _createVNode(_component_the_button, {
                        class: "red small text",
                        disabled: _ctx.isNotHaveActNumber || _ctx.state.is_submit_loading,
                        onClick: ($event: any) => (_ctx.onRemoveCalculation(calculation))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15)),
          _createVNode(_component_page_title, {
            title: "Добавление вычислений",
            class: "mt-6"
          }),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_the_input, {
                placeholder: "Поиск",
                value: _ctx.search_state.query,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search_state.query) = $event)),
                disabled: _ctx.isNotHaveActNumber || _ctx.state.is_submit_loading
              }, null, 8, ["value", "disabled"])
            ]),
            (_ctx.renderedCalculations.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.renderedCalculations, (calculation) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `search-${calculation.id}`,
                        class: "border border-gray-300 rounded px-3 py-1 flex items-center justify-between"
                      }, [
                        _createElementVNode("div", null, _toDisplayString(calculation.invoiceNumber), 1),
                        (_ctx.isCalculationAlreadyAdded(calculation.id))
                          ? (_openBlock(), _createBlock(_component_the_button, {
                              key: 0,
                              class: "red small text",
                              disabled: _ctx.isNotHaveActNumber || _ctx.state.is_submit_loading,
                              onClick: ($event: any) => (_ctx.onRemoveCalculation(calculation))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]))
                          : (_openBlock(), _createBlock(_component_the_button, {
                              key: 1,
                              class: "green small text",
                              disabled: _ctx.isNotHaveActNumber || _ctx.state.is_submit_loading,
                              onClick: ($event: any) => (_ctx.onAddCalculation(calculation))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 2
                            }, 1032, ["disabled", "onClick"]))
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_the_button, {
                      class: "small primary",
                      disabled: _ctx.state.is_submit_loading,
                      onClick: _ctx.addAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Выбрать все ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_the_button, {
              class: "primary small",
              loading: _ctx.state.is_submit_loading,
              disabled: _ctx.isNotHaveActNumber,
              onClick: _ctx.onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Сохранить ")
              ]),
              _: 1
            }, 8, ["loading", "disabled", "onClick"])
          ])
        ], 64))
  ]))
}